import { debounce } from './debounce'
import { lenis } from './lenis-smooth-scroll'

const root = document.documentElement
let headerHeight = getComputedStyle(root)
  .getPropertyValue('--header-height-float')
  .replace('px', '')

window.addEventListener(
  'resize',
  debounce(function (event) {
    headerHeight = getComputedStyle(root)
      .getPropertyValue('--header-height-float')
      .replace('px', '')
  })
)

// smooth scroll for anchor tags
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    const elem = document.querySelector(this.getAttribute('href'))
    const elemTop = elem.offsetTop
    const currentScrollTop = window.scrollY

    if (elemTop < currentScrollTop) {
      const offset = window.innerWidth > 1024 ? -headerHeight : 0
      if (window.innerWidth > 1024) {
        lenis.scrollTo(elem, { offset })
      } else {
        scrollToId(elem.id, { offset })
      }
    } else {
      if (window.innerWidth > 1024) {
        lenis.scrollTo(elem)
      } else {
        scrollToId(elem.id)
      }
    }
  })
})

// Zbieranie wszystkich elementów z klasą 'scrollFrom' i 'scrollTo' do tablic
const scrollFromElements = [].slice.call(
  document.querySelectorAll('.scrollFrom')
)
const scrollToElements = [].slice.call(document.querySelectorAll('.scrollTo'))

// Dodanie event listenerów do każdego elementu z 'scrollFrom'
scrollFromElements.forEach((element, i) => {
  element.addEventListener(
    'click',
    function () {
      // Sprawdzenie szerokości okna
      if (window.innerWidth > 1024) {
        // Użycie lenis.scrollTo dla szerokości większej niż 1024px
        lenis.scrollTo(scrollToElements[i], { offset: -headerHeight })

      } else {
        // Użycie scrollToElement dla szerokości mniejszej lub równej 1024px
        scrollToElement(scrollToElements[i], -headerHeight) // Przekazanie właściwego elementu
      }
    },
    false
  )
})

//Funkcja scrollToElement do płynnego przewijania do określonego elementu z offsetem
// function scrollToElement(elem, offset) {
//   // Sprawdzenie czy przekazany element jest prawidłowym DOM elementem
//   if (elem && typeof elem.getBoundingClientRect === 'function') {
//     const rect = elem.getBoundingClientRect()
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop
//     const targetY = rect.top + scrollTop + offset

//     // Płynne przewijanie do obliczonej pozycji
//     window.scrollTo({
//       top: targetY,
//       behavior: 'smooth',
//     })
//   } else {
//     console.error('Invalid element passed to scrollToElement')
//   }
// }

// scrollFromElements.forEach((element, i) => {
//   element.addEventListener(
//     'click',
//     function () {
//       if (window.innerWidth > 1024) {
//         lenis.scrollTo(scrollToElements[i], { offset })
//       } else {
//         scrollToElement(scrollToElements, headerHeight)
//       }
//     },
//     false
//   )
// })

function scrollToId(id) {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
    })
  }
}

function scrollToElement(elem, offset = 0) {
  const y = elem.getBoundingClientRect().top + window.pageYOffset + offset
  window.scrollTo({
    top: y,
    behavior: 'smooth',
  })
}
